import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Typography,
  Container,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import saveIcon from "../assets/images/save-icon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect } from "react";
import { setUpPassword, verifySetUp } from "../apis/apisList/userApi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
const auth_box = {
  logRegBox: {
    display: "flex",
    padding: "60px 60px 30px 60px",
    justifyContent: "center",
  },
};

const passwordBox = {
  currentPass: {
    width: { sx: "100%", md: "48.5%" },
  },
  newPassPass: {
    width: { sx: "100%", md: "48.5%" },
  },
  confirmPass: {
    width: { sx: "100%", md: "48.5%" },
  },
  newPassBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  btnSavePass: {
    background: "#065F9C",
    borderRadius: "10px",
    fontSize: "16px",
    width: "auto",
    padding: "15px 30px",
    lineHeight: "1.2",
  },
};

const SetUpPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = localStorage.getItem("user");
  const userData = JSON.parse(user);
  const user_id = userData?._id;

  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  const validatePasswords = () => {
    let tempErrors = {};
    setMessage("");

    if (!passwords.newPassword) {
      tempErrors.newPassword = "New password is required.";
    } else if (passwords.newPassword.length < 6) {
      tempErrors.newPassword = "Password must be at least 6 characters long.";
    }

    if (!passwords.confirmPassword) {
      tempErrors.confirmPassword = "Confirm password is required.";
    } else if (passwords.newPassword !== passwords.confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords({ ...passwords, [name]: value });
  };

  const handleSave = async () => {
    if (validatePasswords()) {
      setIsLoading(true);
      const setData = {
        password: passwords.newPassword,
        confirmPassword: passwords.confirmPassword,
      };


      
      setUpPassword(token, setData)
        .then((res) => {
          if (res?.success) {
            toast.success(res?.message);
            navigate("/login", { replace: true });
          } else {
            toast?.error(res?.message);
          }
        })
        .catch((err) => {
          if (err?.status === "401") {
            navigate("/login", { replace: true });
          }
          if (err?.response?.data?.message) {
            toast.error(err?.response?.data.message || "Internal Server Error");
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    verifySetUp(token)
      .then((res) => {
        if (res?.success) {
        } else {
          navigate("/login", { replace: true });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          navigate("/login", { replace: true });
        }
      });
  }, []);

  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame">
        <Box className="backBtnFrame">
          <Button
            className="backBtn"
            variant="contained"
            sx={{ marginBottom: 2 }}
            onClick={() => (window.location.href = "/")}
          >
            <ArrowBackIcon sx={{ marginRight: 1 }} />
            Back to Homepage
          </Button>
        </Box>

        <Box
          style={auth_box.logRegBox}
          sx={{ display: { xs: "block", sm: "block", md: "flex" } }}
        >
          <Box
            className="passwordRowBox"
            sx={{
              maxWidth: "100%",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              width: "50%",
            }}
          >
            {/* Current Password */}

            <Box
              className="newPassRow"
              sx={{
                display: { xs: "flex", sm: "flex", md: "flex" },
                flexDirection: { xs: "column", sm: "column", md: "column" },
                gap: { xs: "15px", sm: "15px", md: "15px" },
              }}
            >
              {/* New Password */}
              <TextField
                style={passwordBox.newPassPass}
                sx={{
                  marginBottom: 0,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
                label="New Password"
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                value={passwords.newPassword}
                onChange={handlePasswordChange}
                fullWidth
                error={!!errors.newPassword}
                helperText={errors.newPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        edge="end"
                      >
                        {showNewPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Confirm Password */}
              <TextField
                style={passwordBox.confirmPass}
                sx={{
                  marginBottom: 0,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
                label="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={handlePasswordChange}
                fullWidth
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* Message */}
            {message && (
              <Typography
                color={
                  message === "Password changed successfully!"
                    ? "success.main"
                    : "error.main"
                }
                sx={{ marginBottom: 2 }}
              >
                {message}
              </Typography>
            )}

            {/* Save Button */}
            <Box
              className="savePassWord"
              sx={{
                textAlign: "center",
              }}
            >
              <Button
                style={passwordBox.btnSavePass}
                variant="contained"
                color="primary"
                onClick={handleSave}
                fullWidth
              >
                <img
                  src={saveIcon}
                  alt="Save Password"
                  style={{ width: 24, height: 24 }}
                />
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default SetUpPassword;
